import { app } from '../../../../../app';
import { Controller } from './access-control-policy.controller';

app.component('companyManageApplicationAccessControlPolicy', {
    bindings: {
        application: '<',
        companyId: '<',
        authenticationAccessPolicyList: '<',
    },
    controller: Controller,
    templateUrl: require('./access-control-policy.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/access-control-policy/access-control-policy.component.js